module.exports = __webpack_public_path__ + "images/file_icons_v2/docx-364d0ce392f9da3be13e30c7cd46269d.svg";